import styled from '@emotion/styled'
import {Settings as SettingsIcon} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import Avatar from '../../../../components/Avatar/Avatar'
import FlatButton from '../../../../components/FlatButton'
import Row from '../../../../components/Row/Row'
import RowActions from '../../../../components/Row/RowActions'
import RowInfo from '../../../../components/Row/RowInfo'
import RowInfoCopy from '../../../../components/Row/RowInfoCopy'
import RowInfoHeader from '../../../../components/Row/RowInfoHeader'
import RowInfoHeading from '../../../../components/Row/RowInfoHeading'
import SecondaryButton from '../../../../components/SecondaryButton'
import TagBlock from '../../../../components/Tag/TagBlock'
import TierTag from '../../../../components/Tag/TierTag'
import {MenuPosition} from '../../../../hooks/useCoords'
import useRouter from '../../../../hooks/useRouter'
import useTooltip from '../../../../hooks/useTooltip'
import {PALETTE} from '../../../../styles/paletteV3'
import defaultOrgAvatar from '../../../../styles/theme/images/avatar-organization.svg'
import {Breakpoint} from '../../../../types/constEnums'
import plural from '../../../../utils/plural'

const RowInner = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap'
})

const OrgAvatar = styled('div')({
  cursor: 'pointer',
  display: 'none',
  width: '2.75rem',
  [`@media screen and (min-width: ${Breakpoint.SIDEBAR_LEFT}px)`]: {
    display: 'block',
    marginRight: 16
  }
})

const Name = styled(RowInfoHeading)({
  cursor: 'pointer'
})

const StyledTagBlock = styled(TagBlock)({
  display: 'block'
})

const StyledButton = styled(SecondaryButton)({
  height: 36,
  marginLeft: 8,
  padding: 0,
  width: 36
})

const StyledIcon = styled('div')({
  color: PALETTE.SLATE_600,
  height: 18,
  width: 18,
  svg: {
    fontSize: 18
  }
})

const StyledRowInfo = styled(RowInfo)({
  paddingLeft: 0
})

const StyledFlatButton = styled(FlatButton)({
  height: 36,
  paddingLeft: 8,
  paddingRight: 8,
  [`@media screen and (min-width: ${Breakpoint.SIDEBAR_LEFT}px)`]: {
    paddingLeft: 16,
    paddingRight: 16
  }
})

const StyledRowInfoCopy = styled(RowInfoCopy)({
  alignItems: 'center',
  display: 'flex'
})





const OrganizationRow = (props) => {
  const {organization: organizationRef} = props
  const organization = useFragment(
    graphql`
      fragment OrganizationRow_organization on Organization {
        id
        name
        orgUserCount {
          activeUserCount
          inactiveUserCount
        }
        picture
        tier
        billingTier
      }
    `,
    organizationRef
  )
  const {history} = useRouter()
  const {
    id: orgId,
    name,
    orgUserCount: {activeUserCount, inactiveUserCount},
    picture,
    tier,
    billingTier
  } = organization
  const orgAvatar = picture || defaultOrgAvatar
  const onRowClick = () => {
    closeTooltip()
    history.push(`/me/organizations/${orgId}`)
  }
  const totalUsers = activeUserCount + inactiveUserCount
  const showUpgradeCTA = billingTier === 'starter'
  const {tooltipPortal, openTooltip, closeTooltip, originRef} = useTooltip(
    MenuPosition.UPPER_CENTER
  )
  return (
    React.createElement(Row, null
      , React.createElement(OrgAvatar, { onClick: onRowClick,}
        , React.createElement(Avatar, { size: 44, picture: orgAvatar,} )
      )
      , React.createElement(RowInner, null
        , React.createElement(StyledRowInfo, null
          , React.createElement(RowInfoHeader, null
            , React.createElement(Name, { onClick: onRowClick,}, name)
            , tier !== 'starter' && (
              React.createElement(StyledTagBlock, null
                , React.createElement(TierTag, { tier: tier, billingTier: billingTier,} )
              )
            )
          )
          , React.createElement(StyledRowInfoCopy, null
            , `${totalUsers} ${plural(totalUsers, 'User')} (${activeUserCount} Active)`
          )
        )
        , React.createElement(RowActions, null
          , showUpgradeCTA && (
            React.createElement(StyledFlatButton, { onClick: onRowClick, palette: 'blue',}
              , 'Upgrade'
            )
          )
          , React.createElement(StyledButton, {
            onClick: onRowClick,
            onMouseEnter: openTooltip,
            onMouseLeave: closeTooltip,
            ref: originRef,}

            , React.createElement(StyledIcon, null
              , React.createElement(SettingsIcon, null )
            )
          )
          , tooltipPortal('Settings')
        )
      )
    )
  )
}

export default OrganizationRow
